const kolDefinitionReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_KOL_DEFINITION_DATA":
      return {
        ...state,
        kolData: action.payload
      };
    case "API_START":
      if (action.payload === "FETCH_KOL_DEFINITION_DATA") {
        return {
          ...state,
          isLoadingKolData: true
        };
      }
      break;
    case "API_END":
      if (action.payload === "FETCH_KOL_DEFINITION_DATA") {
        return {
          ...state,
          isLoadingKolData: false
        };
      }
      break;
    default:
      return state;
  }
  return state;
};

export default kolDefinitionReducer;
